import React, { Component } from 'react';
import Submenu from './Submenu';
import { Link } from 'react-router-dom';

class Menu extends Component {
  state = {
    openDropdown: false,
  };

  handleToggleSubmenu = () => () => {
    this.setState({
      openDropdown: !this.state.openDropdown,
    });
  };

  render() {
    const { sprofil, pathname, m, c } = this.props;
    const { openDropdown } = this.state;
    let url = m.alias;
    const regex = new RegExp(url);
    const isActive = regex.test(pathname);
    const getMenu =  c && c.m && c.m.filter((menu) => {
      return menu.id === m.id;
    })[0];
    let rootPath = '/' + pathname.split('/').filter((e) => /\S/.test(e))[0];
    if (m.id === 'progressreport' && sprofil) {
      if (!sprofil.isTK) return <></>;
    }
    if (m.id === 'erapor' && sprofil) {
      if (!sprofil.isSD && !sprofil.isSMP && !sprofil.isSMA) return <></>;
    }
    if (m.id === 'rapor-mid' && sprofil) {
      if (!sprofil.isSD && !sprofil.isSMP && !sprofil.isSMA) return <></>;
    }
    
    return (
      <>
        {getMenu && getMenu.v === true && (
          <li>
            {m.subm.length === 0 && (
              <Link
                to={m.url}
                className={
                  rootPath === m.url
                    ? `disable-select is-active custom-text-14 custom-text-overflow custom-hover-light-info`
                    : 'disable-select custom-text-14 custom-text-overflow custom-hover-light-info'
                }
              >
                <i className={`fas fa-${m.icon} icon`} /> {m.title}
              </Link>
            )}
            {m.subm.length > 0 && (
              <div
                onClick={this.handleToggleSubmenu('')}
                className={
                  isActive === true
                    ? `disable-select has-background-white-ter custom-text-14 custom-text-overflow`
                    : 'disable-select custom-text-14 custom-text-overflow'
                }
              >
                <i className={`fas fa-${m.icon} icon`} /> {m.title}
              </div>
            )}
            <ul className={openDropdown === true ? '' : 'is-hidden'}>
              {m.subm.map((i, x) => (
                <Submenu key={i.id} subm={i} c={c.subm} pathname={pathname} />
              ))}
            </ul>
          </li>
        )}
      </>
    );
  }
}

export default Menu;
